import * as React from 'react';
import * as ReactDOM from 'react-dom';

export interface IPopupPortalProps extends React.HTMLProps<HTMLElement> {
  children?: React.ReactNode;
  containerStyle?: string;
}

export function PopupPortal({ children, containerStyle }: IPopupPortalProps) {
  if (!children || typeof window === 'undefined') {
    return null;
  }

  const portalWithContainer = (
    <div data-mark="PopupPortal" className={containerStyle}>
      {children}
    </div>
  );

  // Компонент не может вернуть портал как сущность, однако портал может быть обернут во фрагмент
  return ReactDOM.createPortal(React.Children.only(portalWithContainer), document.body);
}
